import { withPresetIconProps } from './withPresetIconProps';
import BoldIcon from '@wix/da-ds/pkg/Icons/24x24/Bold';
import ItalicIcon from '@wix/da-ds/pkg/Icons/24x24/Italic';
import UnderlineIcon from '@wix/da-ds/pkg/Icons/24x24/Underline';
import QuoteIcon from '@wix/da-ds/pkg/Icons/24x24/Quote';
import LeftAlignIcon from '@wix/da-ds/pkg/Icons/24x24/LeftAlign';
import CenterAlignIcon from '@wix/da-ds/pkg/Icons/24x24/CenterAlign';
import RightAlignIcon from '@wix/da-ds/pkg/Icons/24x24/RightAlign';
import BlockAlignIcon from '@wix/da-ds/pkg/Icons/24x24/BlockAlign';
import NumberedListIcon from '@wix/da-ds/pkg/Icons/24x24/NumberedList';
import BulletListIcon from '@wix/da-ds/pkg/Icons/24x24/BulletList';
import TextSizeIcon from '@wix/da-ds/pkg/Icons/24x24/TextSize';
import GifIcon from '@wix/da-ds/pkg/Icons/24x24/AddGif';
import LinkIcon from '@wix/da-ds/pkg/Icons/24x24/Link';
import AddImageIcon from '@wix/da-ds/pkg/Icons/24x24/AddImage';
import AddVideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import AddGalleryIcon from '@wix/da-ds/pkg/Icons/24x24/AddGallery';
import CenterImageIcon from '@wix/da-ds/pkg/Icons/24x24/CenterImage';
import FullWidthImageIcon from '@wix/da-ds/pkg/Icons/24x24/FullWidthImage';
import FloatLeftIcon from '@wix/da-ds/pkg/Icons/24x24/FloatLeft';
import FloatRightIcon from '@wix/da-ds/pkg/Icons/24x24/FloatRight';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import GalleryGridIcon from '@wix/da-ds/pkg/Icons/24x24/GalleryGrid';
import GalleryTorpedoIcon from '@wix/da-ds/pkg/Icons/24x24/GalleryTorpedo';
import SettingsIcon from '@wix/da-ds/pkg/Icons/24x24/Settings';
export var Bold = withPresetIconProps(BoldIcon);
export var Italic = withPresetIconProps(ItalicIcon);
export var Underline = withPresetIconProps(UnderlineIcon);
export var Blockquote = withPresetIconProps(QuoteIcon);
export var AlignLeft = withPresetIconProps(LeftAlignIcon);
export var AlignCenter = withPresetIconProps(CenterAlignIcon);
export var AlignRight = withPresetIconProps(RightAlignIcon);
export var AlignJustify = withPresetIconProps(BlockAlignIcon);
export var OrderedList = withPresetIconProps(NumberedListIcon);
export var UnorderedList = withPresetIconProps(BulletListIcon);
export var TextSize = withPresetIconProps(TextSizeIcon);
export var inactiveIconTitle = TextSize;
export var TitleOne = TextSize;
export var TitleTwo = TextSize;
export var CenterImage = withPresetIconProps(CenterImageIcon);
export var FullWidthImage = withPresetIconProps(FullWidthImageIcon);
export var FloatLeft = withPresetIconProps(FloatLeftIcon);
export var FloatRight = withPresetIconProps(FloatRightIcon);
export var Edit = withPresetIconProps(EditIcon);
export var Delete = withPresetIconProps(TrashcanIcon);
export var GalleryGrid = withPresetIconProps(GalleryGridIcon);
export var GalleryTorpedo = withPresetIconProps(GalleryTorpedoIcon);
export var Settings = withPresetIconProps(SettingsIcon);
export var Link = withPresetIconProps(LinkIcon);
export var Gif = withPresetIconProps(GifIcon);
export var AddImage = withPresetIconProps(AddImageIcon);
export var AddVideo = withPresetIconProps(AddVideoIcon);
export var AddGallery = withPresetIconProps(AddGalleryIcon);
//# sourceMappingURL=icons.js.map